import BaseService from "@/services/BaseService";
import AppUtils from "@/utils/BaseUtils/AppUtils";

class NotificationMessageServices extends BaseService {
  readNotifications(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.notification.READ_NOTIFICATIONS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  updateStatus(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.notification.UPDATE_STATUS,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
}

export default NotificationMessageServices;
